import * as React from 'react';

export interface PageNumberProps {
  currentPage: number;
  numPages: number;
}

export const PageNumber: React.SFC<PageNumberProps> = (props) => {
  const currentPage: number = props.currentPage + 1;
  const numPages: number = props.numPages;
  return (
    <span className="page-number">{currentPage} / {numPages}</span>
  );
};
